// Ensure JIT compiler is available when AOT skips a module's metadata at runtime
// (Angular suggests importing '@angular/compiler' before bootstrapping in such cases)
import '@angular/compiler';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { installEmptyInnerHtmlWorkaround } from './app/shared/security/empty-inner-html-workaround';

installEmptyInnerHtmlWorkaround();

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error('[Bootstrap] Error de aplicación:', err));
